import React from 'react';
import API from '../../configAPI';
import ItemList from '../partials/ItemList';
import {Link} from 'react-router-dom';
import ProductItem from '../product/ProductItem';
import PostPreview from '../posts/PostPreview';
import PulseLoader from 'react-spinners/PulseLoader';
import CONFIG from '../../config';
class SearchResults extends React.Component{
    constructor(props){
        super(props);
        this.state ={
            items: [],
            providers: [],
            products: [],
            posts: [],
            loading: true
        }
    }
    componentDidMount(){
        this.getSearchResults();
    }
    componentDidUpdate(prevProps){
        if(this.props.match.params.text !== prevProps.match.params.text){
            this.getSearchResults();
        }
    }

    getSearchResults = () =>{
        this.setState({loading: true});
        API.PRODUCTS(`search?text=${this.props.match.params.text}`)
        .then(resp =>{
            this.setState({
                items: resp.data.items,
                providers: resp.data.providers,
                products: resp.data.products,
                posts: resp.data.posts,
                loading: false
            });
        })
        .catch(err =>{
            console.log(err);
        });
    }

    render(){
        const active_providers = this.state.providers.filter(prov =>{
            return prov.status === 1;
        });
        const active_products = this.state.products.filter(prod =>{
            return prod.enabled === 1;
        });

        const providerList = active_providers.map((prov,index) =>
            <div className="col-xs-12 col-md-3 mt-1 mb-1" key={index}>
                <div className="card full-height">
                    <div className="card-header">
                    {prov.name}
                    </div>
                    <div className="card-body text-center d-flex flex-column justify-content-between">
                    <div className="p-4">
                        <img src={prov.url_logo} className="img-fluid" alt={prov.name}/>
                    </div>
                    <Link to={`/empresa/${prov.slug}`} className="btn btn-secondary btn-sm">{prov.products_count} Productos disponibles</Link>
                    </div>
                </div>
            </div>
        );
        return(
            <div className="container-fluid mt-3 mb-3">
                <div className="col-12">
                    <PulseLoader
                        css={CONFIG.spinner_css}
                        size={CONFIG.spinner_size}
                        margin={CONFIG.spinner_margin}
                        color={CONFIG.spinner_color}
                        loading={this.state.loading}
                    />
                    <div className="row mb-2">
                        <div className="col-12">
                            <h4>Resultados de búsqueda</h4>
                        </div>
                        <div className="col-12">
                            <h5>Productos</h5>
                            <div className="d-flex flex-wrap mt-1">
                                {this.state.products.length > 0 ? <ProductItem products={active_products}/> : 'Sin resultados'}
                            </div>
                            <hr/>
                            <h5>Categorías</h5>
                            {this.state.items.length > 0 ? <ItemList items={this.state.items} /> : 'Sin resultados'}
                            <hr/>
                            <h5>Empresas</h5>
                            <div className="col-12">
                                <div className="row mt-3 mb-3">
                                    {this.state.providers.length > 0 ? providerList : 'Sin resultados'}
                                </div>
                            </div>
                            <hr/>
                            
                            <h5>Posts</h5>
                            <div className="d-flex flex-wrap mt-1">
                                {this.state.posts.length > 0 ? <PostPreview posts={this.state.posts}/> : 'Sin resultados'}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default SearchResults;